export const authContext = {
    AccessToken: '',
    IdToken: '',
    RefreshToken: '',
    TokenType: '', 
    isUserLoggedIn : '',
    userEmail : '',
    userName: '',
    guid : ''
}